module.exports = __webpack_public_path__ + "static/media/6.45c3880f.png";